import { render } from "./ClientDetailsCard.vue?vue&type=template&id=5d23cf31"
import script from "./ClientDetailsCard.vue?vue&type=script&lang=js"
export * from "./ClientDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__